import {Component, computed, input, ChangeDetectionStrategy} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {VariantConditionNodeSettingsComponent} from "@app/pricing/components/node-settings/variant-condition-node/variant-condition-node.component"
import {PricedItemNode, PricingNode, VariantConditionNode} from "@cm/pricing"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-node-settings",
    templateUrl: "./node-settings.component.html",
    styleUrl: "./node-settings.component.scss",
    imports: [ToggleComponent, VariantConditionNodeSettingsComponent, MatTooltipModule],
})
export class NodeSettingsComponent {
    readonly $node = input<PricingNode>(undefined, {alias: "node"})
    readonly $pricedItemNode = computed<PricedItemNode | undefined>(() => {
        if (this.$node() instanceof PricedItemNode) return this.$node() as PricedItemNode
        return undefined
    })
    readonly $variantConditionNode = computed<VariantConditionNode | undefined>(() => {
        const condition = this.$pricedItemNode()?.parameters.condition
        return condition instanceof VariantConditionNode ? condition : undefined
    })
}
